import styled from 'styled-components';

import { fonts } from '@dreryk/react-components';

export const StyledGuardianCellGuardianName = styled.span`
   font-weight: ${fonts.fontWeightBold};
`;
StyledGuardianCellGuardianName.displayName = 'StyledGuardianCellGuardianName';
